import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import "../styles.css";

const Patients = () => {
  const [patients, setPatients] = useState([]);

  useEffect(() => {
    // Professional demo data
    const demoPatients = [
      { id: 1, name: "Alice Smith", age: 28, gender: "Female" },
      { id: 2, name: "Bob Johnson", age: 34, gender: "Male" },
      { id: 3, name: "Clara Lee", age: 42, gender: "Female" },
      { id: 4, name: "David Miller", age: 51, gender: "Male" },
      { id: 5, name: "Emily Carter", age: 23, gender: "Female" },
      { id: 6, name: "Farhan Patel", age: 37, gender: "Male" },
      { id: 7, name: "Grace Thompson", age: 45, gender: "Female" },
      { id: 8, name: "Hassan Ali", age: 30, gender: "Male" },
      { id: 9, name: "Isabella Rodrigues", age: 39, gender: "Female" },
      { id: 10, name: "James Anderson", age: 56, gender: "Male" },
      { id: 11, name: "Khadija Noor", age: 26, gender: "Female" },
      { id: 12, name: "Liam O'Connor", age: 48, gender: "Male" },
      { id: 13, name: "Maria Fernandez", age: 33, gender: "Female" },
      { id: 14, name: "Nathan Brooks", age: 41, gender: "Male" },
      { id: 15, name: "Olivia Brown", age: 29, gender: "Female" },
    ];

    setPatients(demoPatients);
  }, []);

  return (
    <div>
      <Navbar />
      <div className="page-container">
        <h1 className="page-title">Patient Directory</h1>
        <p className="page-subtitle">
          Registered patients overview and demographic information
        </p>

        <div className="page-card">
          {patients.length === 0 ? (
            <p className="empty-state">No patients found.</p>
          ) : (
            <table className="patients-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Full Name</th>
                  <th>Age</th>
                  <th>Gender</th>
                </tr>
              </thead>
              <tbody>
                {patients.map((p, index) => (
                  <tr key={p.id}>
                    <td>{index + 1}</td>
                    <td>{p.name}</td>
                    <td>{p.age}</td>
                    <td>{p.gender}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default Patients;